import {
    baseUsageAtom,
    basicInfoExpandAtom,
    electricHeatAtom,
    flexAtom,
    hasAcAtom,
    hasHeatPumpAtom,
    hhSizeAtom,
    sqftAtom,
    storiesAtom,
    utilityCoAtom,
    yearBuiltAtom,
    zipCodeAtom,
} from '@/ui/atoms/form-atoms';
import { useAtom } from 'jotai';
import { useCallback } from 'react';
import { useClearInputs } from './useClearInputs';

export function useResetInputs() {
    const [expand, setExpand] = useAtom(basicInfoExpandAtom);

    const [flex, setFlex] = useAtom(flexAtom);
    const [baseUsage, setBaseUsage] = useAtom(baseUsageAtom);
    const [zipCode, setZipCode] = useAtom(zipCodeAtom);
    const [yearBuilt, setYearBuilt] = useAtom(yearBuiltAtom);
    const [sqft, setSqft] = useAtom(sqftAtom);
    const [hhSize, setHhSize] = useAtom(hhSizeAtom);
    const [utilityCo, setUtilityCo] = useAtom(utilityCoAtom);

    const [hasAc, setHasAc] = useAtom(hasAcAtom);
    const [electricHeat, setElectricHeat] = useAtom(electricHeatAtom);
    const [stories, setStories] = useAtom(storiesAtom);
    const [hasHeatPump, setHasHeatPump] = useAtom(hasHeatPumpAtom);

    const clearBasic = useCallback(() => {
        setExpand(true);

        setFlex(false);
        setBaseUsage('');
        setZipCode('');
        setYearBuilt('');
        setSqft('');
        setHhSize('');
        setUtilityCo('');
        setStories('');

        setHasAc(false);
        setElectricHeat(false);
        setHasHeatPump(false);
    }, [
        setBaseUsage,
        setElectricHeat,
        setExpand,
        setFlex,
        setHasAc,
        setHasHeatPump,
        setHhSize,
        setSqft,
        setStories,
        setUtilityCo,
        setYearBuilt,
        setZipCode,
    ]);

    const { clearAll } = useClearInputs();

    const resetAll = useCallback(() => {
        clearBasic();
        clearAll();
    }, [clearAll, clearBasic]);

    return resetAll;
}
